<template src="@/templates/footer.html"></template>

<script>

    import objLogo from '@/assets/logo2.png';
    import {authorizationService} from '../authorization/authorizationService';

    export default {
        name: "footerComponent",
        data() {
            return {
                routeName: this.$route.name,
                activeIndex: '1',
                imgLogo: objLogo,
                uploadsVisible: false,
                resetPasswordVisible: false,
                userVisible: false,
                groupsVisible: false,
                isAdmin: false,
                isToggleable: 'sm',

            };

        },
        props: {
            propUserName: String
        },
        methods: {
            linkTo(route) {
                // console.log(route);
                // This delay is required to make sure store has been updated before router navigation
                let thisComp = this;
                setTimeout(function () {
                    thisComp.$router.push({path: route});
                }, 5);
            },
            getMenu() {
                let self = this;
                authorizationService.getMenu()
                    .then(res => {
                        self.setMenu(res.data);
                    }).catch(err => {
                    console.log(err);
                });
            },
            setMenu(menuItems) {
                if (menuItems != null) {
                    this.uploadsVisible = menuItems.filter(x => x.path === "/Uploads").length > 0;
                    this.resetPasswordVisible = menuItems.filter(x => x.path === "/ResetPassword").length > 0;
                    this.userVisible = menuItems.filter(x => x.path === "/Users").length > 0;
                    this.groupsVisible = menuItems.filter(x => x.path === "/Groups").length > 0;
                    this.dashboardVisible = menuItems.filter(x => x.path === "/Dashboard").length > 0;
                }
            },
            goToPage(routeName) {
                this.$router.push(routeName);
            },
            redirect(routeName) {
                window.location.href = '/#' + routeName;
            },
            getUserName() {
                return localStorage.getItem("userName");
            }
        },
        created() {
            this.$forceUpdate();
            this.isAdmin = localStorage.getItem("isAdmin") === "true";
        },
    }
</script>

<style scoped>

    @media (min-width: 414px) {
        .myFooter-left .footer-allgrads,
        .myFooter-left .footer-privacy,
        .myFooter-left .footer-disclaimer,
        .myFooter-left .footer-contact-us {
            display: none;
        }

    }

    @media (min-width: 1200px) {
        .myFooter-left .footer-privacy {
            display: none;
        }
    }

    @media (min-width: 1480px) {
        .myFooter-left .footer-privacy {
            display: inline-block;
        }
    }
	
    @media (min-width: 930px) {
        /*.navbar-toggler {*/
        /*display: block;*/
        /*}*/
        .navbar-nav {
            /*display: none;*/
        }
    }
	
	.myFooter >>> li {
		border-left: none !important;
	}
	
	.navContent >>> a {
		padding: 0 !important;
		border-left: 1px solid #f0eff0 !important;
	}

</style>



// WEBPACK FOOTER //
// src/components/footer.vue